"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const initialState = {
    includeServerLog: false,
    showHiddenProperties: false,
    showHiddenResults: false
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case "SetDebugSettings": {
            return {
                includeServerLog: action.includeServerLog,
                showHiddenProperties: action.showHiddenProperties,
                showHiddenResults: action.showHiddenResults
            };
        }
        case "Dummy": {
            return state;
        }
        default: {
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
        }
    }
}
//# sourceMappingURL=state.js.map